import { DirectiveOptions } from 'vue';

enum Services {
    Facebook = 'facebook',
    Twitter = 'twitter',
}

const popupWidth: number = 400;
const popupHeight: number = 300;

const openPopup = (url: string, title: string, width: number, height: number) => {
    const w = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const h = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const left = (w / 2) - (width / 2) +  10;
    const top  = (h / 2) - (height / 2) +  50;
    const popup = window.open(url, title, `scrollbars=yes, width=${width}, height=${height}, top=${top}, left=${left}`);

    if (popup) {
        popup.focus();
    }
};

const onClick = (service: string, url: string, title: string, description?: string) => (event: Event): void => {
    switch (service) {
        case Services.Facebook:
            event.preventDefault();
            const serviceUrl: string = `https://www.facebook.com/sharer/sharer.php?u={url}&t={title}`;
            openPopup(
                serviceUrl
                    .replace('{url}', encodeURIComponent(url))
                    .replace('{title}', encodeURIComponent(title)),
                title,
                popupWidth,
                popupHeight,
            );
            break;
        case Services.Twitter:
            break;
        default:
            break;
    }

    return;
};

let callback: any = null;

const getMeta = (name: string, attr: string): string => {
    const metas = document.getElementsByTagName('meta');
    let result = '';
    Object.keys(metas).forEach((key) => {
        const meta: HTMLMetaElement = metas[key];
        if (meta.name === name) {
            result = meta.getAttribute(attr) || '';
            return;
        }
    });
    return result;
};

const share: DirectiveOptions = {
    bind: (el: HTMLElement, { value: { type, url, title, description } }: { value: { type: string, url?: string, title?: string, description?: string } }): void => {
        callback = onClick(type, url || window.location.href, title || document.title, description || getMeta('description', 'content'));
        el.addEventListener('click', callback);
    },
    unbind: (el: HTMLElement): void => {
        el.removeEventListener('click', callback);
    },
};

export default share;



// WEBPACK FOOTER //
// ./src/directives/share.ts